import { lazy } from "react";
import { Navigate, Outlet } from "react-router-dom";

// ----------------------------------------------------------------------

const Page500 = lazy(() => import("src/pages/500"));
const Page402 = lazy(() => import("src/pages/402"));
const Page403 = lazy(() => import("src/pages/403"));
const Page404 = lazy(() => import("src/pages/404"));
//

// ----------------------------------------------------------------------

export const otherRoutes = [
    {
        path: "/",
        element: (
            <Outlet />
        ),
        children: [
            { path: "500", element: <Page500 /> },
            { path: "404", element: <Page404 /> },
            { path: "403", element: <Page403 /> },
            { path: "402", element: <Page402 /> },
            //
        ]
    },

    // No match 404
    {
        path: "*",
        element: <Navigate to="/404" replace />
    }
];
